module.exports = __webpack_public_path__ + "static/media/SDFSA_7-384w.0e95edc0.webp";